'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleX, iconCircleXTag } from '@ni/nimble-components/dist/esm/icons/circle-x';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleX };
export { iconCircleXTag };
export const NimbleIconCircleX = wrap(IconCircleX);